// Core
import { NavigationGuard, RouteLocationRaw } from "vue-router";

// Stores
import pinia from "@/store/pinia";

// Types
import { UserParamsT } from "@/@types/user";

// Stores
import { useUserStore } from "@/store/user";
import { useTeamStore } from "@/store/team";

const requireInvite: NavigationGuard = async (to, _from, next) => {
  try {
    const userStore = useUserStore(pinia);
    const infos = userStore.userInfos;

    const { inviteId, email, token } = to.query as UserParamsT;

    // Se há parâmetros de convite na URL mas o usuário não está logado, permite continuar
    if ((inviteId || token) && !infos?.id) {
      return next();
    }

    // Se não há parâmetros de convite e o usuário não está logado, permite continuar
    if (!inviteId && !token && !infos?.id) {
      return next();
    }

    // Se o usuário está logado, verifica se o email do convite corresponde (apenas se houver inviteId)
    if (inviteId && infos?.id) {
      const emailMatches = email === infos?.email;
      if (!emailMatches) {
        // Email não corresponde, permite continuar para mostrar erro apropriado
        return next();
      }
    }

    // Verifica se o usuário já completou o onboarding
    const onboarded = infos?.onboarding?.hasCompleted || infos?.onboarding?.hasCompletedStep2;

    // Se está na rota de login e o usuário já completou onboarding, redireciona para dashboard
    if (onboarded && to.name === 'login') {
      const dashboard: RouteLocationRaw = { name: "dashboard" };
      if (token) dashboard.query = { token };
      return next(dashboard);
    }

    // Verifica convites pendentes apenas se o usuário estiver logado
    if (infos?.id) {
      try {
        const teamStore = useTeamStore(pinia);
        
        // Verifica se pendingInvites existe antes de acessar length
        const pendingInvites = teamStore.pendingInvites || [];
        const pendingInvite = pendingInvites.length > 0;

        if (pendingInvite) return next();

        const step = infos?.onboarding?.currentStep;
        
        // Se o usuário tem um convite (basic ou token), não deve ser 
        // redirecionado para subscription apenas com base no step
        const hasInvite = infos?.onboarding?.invite || pendingInvite;
        
        if ((step === 6 || step === 5) && !hasInvite) {
          return next("subscription");
        }
      } catch (storeError) {
        // Se houver erro ao acessar a store, continua o fluxo
        console.warn("Error accessing teamStore in requireInvite:", storeError);
      }
    }

    next();
  } catch (error) {
    console.error("Error in requireInvite guard:", error);
    // Permite continuar em caso de erro não crítico
    next();
  }
};

export default requireInvite;
